import { useQuery } from 'react-query';
import { inventoryItemKeys } from './inventoryItemKeys';
import { getInventoryItems } from '../inventoryApi';

export const useGtmVinInventoryQuery = ({ vin = '' }: { vin: string }) => {
  return useQuery(
    [...inventoryItemKeys.all(), vin],
    async () =>
      getInventoryItems({
        search: vin,
        soldFilter: '2',
      }),
    {
      refetchOnWindowFocus: false,
      staleTime: 0, // 1 hour
      enabled: !!vin,
    }
  );
};
